import { render, staticRenderFns } from "./SideBarActions.vue?vue&type=template&id=1b21dc0c&scoped=true&"
import script from "./SideBarActions.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideBarActions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b21dc0c",
  null
  
)

export default component.exports